import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import "./Popup_modal.scss";
import { CircularProgress } from "@mui/material";
import { width } from "@mui/system";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderBottom: "8px solid #FDB81E",
  borderRadius: "8px",
  p: 3,
  width: { xs: "90%", sm: "70%", md: "50%", lg: "40%" }, // Responsive width
  maxWidth: "498px",
  "@media (max-width: 768px)": {
    // padding: "16px", // Reduce padding on small screens
    borderRadius: "6px", // Adjust border radius
    width: "200px",
  },
};

export default function BasicModal({
  setIsOpenPopUp,
  handleDelete,
  open,
  isLoading = false,
  item = {
    title: "",
    description: "",
    icon: true,
    changeEmail: false,
  },
  setNewEmail, // Add this prop
}) {
  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    event.stopPropagation();
    setIsOpenPopUp(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Darken the background slightly
          backdropFilter: "blur(.3px)", // Apply the blur effect
        },
      }}>
      <Box sx={style}>
        <div className='modal_container_01'>
          <div className='fixed_values'>
            {item.icon && (
              <div className='icon_for_modal'>
                <img src='/assets/images/delete_without_fill.svg' alt='Delete icon' className='icon_modal' />
              </div>
            )}
            <div className='heading_modal'>{item.title}</div>
            <div className='desc_modal'>{item.description}</div>
            {item.changeEmail && (
              <div className='email_change_input'>
                <div className='new_email'>
                  <div className='new_email_label'>New Email</div>
                  <input type='newEmail' name='newEmail' placeholder='Enter new email' onChange={(e) => setNewEmail(e.target.value)} />
                </div>
              </div>
            )}
          </div>
          <div className='buttons_box'>
            {isLoading ? (
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleDelete(e);
                }}
                className='delete_btn_circular'
                sx={{ textTransform: "none" }}>
                <CircularProgress size={14} sx={{ color: "#FFFFFF" }} />
              </div>
            ) : (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleDelete(e);
                }}
                className='delete_btn'
                sx={{ textTransform: "none" }}>
                {item.changeEmail ? "Update" : "Confirm"}
              </Button>
            )}
            <Button
              onClick={(e) => {
                e.stopPropagation(); // Stop event propagation
                handleClose(e);
              }}
              className='cancel_btn'
              sx={{ textTransform: "none" }}>
              Cancel
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
